<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-col lg="12" class="ml-auto">
      <notifications group="error" position="top center" class="mt-1" />
      <notifications group="success" position="top left" class="mt-1" />
      <notifications group="info" position="top left" class="mt-1" />
      <notifications group="warn" position="top left" class="mt-1" />
      <loading v-if="vLoading" />
      <v-row>
        <v-row>
          <v-col cols="3">
            <b-card
              style="background-color: #effbfe !important"
              v-if="step == 1"
            >
              <b-card-text
                style="color: #547887 !important"
                class="text-center"
              >
                <v-row>
                  <h3>چه گزارشی میخواهید؟</h3>
                </v-row>
                <v-row>
                  <v-btn @click="selectReportType('annualMonthly')" class="mt-3"
                    >فروش ماهیانه یک سال</v-btn
                  >
                </v-row>
                <v-row>
                  <v-btn
                    @click="selectReportType('annualRequestMonthly')"
                    class="mt-3"
                    >پیش‌فاکتورهای ماهیانه یک سال</v-btn
                  >
                </v-row>
                <v-row>
                  <v-btn @click="selectReportType('compareMonth')" class="mt-3"
                    >مقایسه فروش یک ماه با سال قبل</v-btn
                  >
                </v-row>
                <v-row>
                  <v-btn @click="selectReportType('monthItems')" class="mt-3"
                    >اقلام فروخته شده یک ماه</v-btn
                  >
                </v-row>
                <v-row>
                  <v-btn
                    @click="selectReportType('compareMultipleMonth')"
                    class="mt-3"
                    >مقایسه ماه‌ها</v-btn
                  >
                </v-row>
              </b-card-text>
            </b-card>
            <b-card
              style="background-color: #effbfe !important"
              v-else-if="step > 1"
            >
              <b-card-text
                style="color: #547887 !important"
                class="text-center"
              >
                <v-row>
                  <h3>چه گزارشی میخواهید؟</h3>
                </v-row>
                <v-row>
                  <h4 class="mt-3">
                    {{ reportTypes[selectedReportType].name }}
                  </h4>
                </v-row>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step == 2">
            <b-card style="background-color: #fdf3ec !important">
              <b-card-text
                style="color: #927666 !important"
                class="text-center"
              >
                <v-row>
                  <h3>لطفا سال گزارش را انتخاب کنید</h3>
                </v-row>
                <v-row v-for="year in yearMonthList" :key="year.year">
                  <v-btn @click="selectReportYear(year.year)" class="mt-3">{{
                    year.year
                  }}</v-btn>
                </v-row>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step > 2">
            <b-card style="background-color: #fdf3ec !important">
              <b-card-text
                style="color: #927666 !important"
                class="text-center"
              >
                <v-row>
                  <h3>لطفا سال گزارش را انتخاب کنید</h3>
                </v-row>
                <v-row>
                  <h4 class="mt-3">{{ selectedYear }}</h4>
                </v-row>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step == 6">
            <b-card style="background-color: #f5f2fe !important">
              <b-card-text
                style="color: #605a89 !important"
                class="text-center"
              >
                <v-row>
                  <h3>لطفا ماه گزارش را انتخاب کنید</h3>
                </v-row>
                <v-row
                  v-for="month in yearMonthList.filter(
                    (year) => year.year == selectedYear
                  )[0].month"
                  :key="month"
                >
                  <v-btn @click="selectReportMonth(month)" class="mt-3">{{
                    month
                  }}</v-btn>
                </v-row>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step > 6 && selectedMonth">
            <b-card style="background-color: #f5f2fe !important">
              <b-card-text
                style="color: #605a89 !important"
                class="text-center"
              >
                <v-row>
                  <h3>لطفا ماه گزارش را انتخاب کنید</h3>
                </v-row>
                <v-row>
                  <h4 class="mt-3">{{ selectedMonth }}</h4>
                </v-row>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step == 7">
            <b-card style="background-color: #f5f2fe !important">
              <b-card-text
                style="color: #605a89 !important"
                class="text-center"
              >
                <v-row>
                  <h3>از ماه</h3>
                </v-row>
                <v-row
                  v-for="month in yearMonthList.filter(
                    (year) => year.year == selectedYear
                  )[0].month"
                  :key="month"
                >
                  <v-btn @click="selectReportMonthFrom(month)" class="mt-3">{{
                    month
                  }}</v-btn>
                </v-row>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step > 7 && selectedMonthFrom">
            <b-card style="background-color: #f5f2fe !important">
              <b-card-text
                style="color: #605a89 !important"
                class="text-center"
              >
                <v-row>
                  <h3>از ماه</h3>
                </v-row>
                <v-row>
                  <h4 class="mt-3">{{ selectedMonthFrom }}</h4>
                </v-row>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step == 8">
            <b-card style="background-color: #f5f2fe !important">
              <b-card-text
                style="color: #605a89 !important"
                class="text-center"
              >
                <v-row>
                  <h3>تا ماه</h3>
                </v-row>
                <v-row
                  v-for="month in yearMonthList.filter(
                    (year) => year.year == selectedYear
                  )[0].month"
                  :key="month"
                >
                  <v-btn @click="selectReportMonthTo(month)" class="mt-3">{{
                    month
                  }}</v-btn>
                </v-row>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step > 8 && selectedMonthTo">
            <b-card style="background-color: #f5f2fe !important">
              <b-card-text
                style="color: #605a89 !important"
                class="text-center"
              >
                <v-row>
                  <h3>تا ماه</h3>
                </v-row>
                <v-row>
                  <h4 class="mt-3">{{ selectedMonthTo }}</h4>
                </v-row>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step == 4 || step == 9">
            <b-card style="background-color: #f0fef1 !important">
              <b-card-text
                style="color: #6f9a6e !important"
                class="text-center"
              >
                <v-btn @click="produceReport()" class="mt-3">
                  جهت تهیه گزارش کلیک کنید
                </v-btn>
                <v-btn @click="returnReport()" class="mt-3">
                  شروع مجدد گزا‌رش‌گیری
                </v-btn>
              </b-card-text>
            </b-card>
          </v-col>
          <v-col cols="3" v-if="step == 10 || step == 5">
            <b-card style="background-color: #f0fef1 !important">
              <b-card-text
                style="color: #6f9a6e !important"
                class="text-center"
              >
                <v-btn @click="returnReport()" class="mt-3">
                  شروع مجدد گزا‌رش‌گیری
                </v-btn>
              </b-card-text>
            </b-card>
          </v-col>
        </v-row>
      </v-row>
    </v-col>
    <br />
    <v-col lg="12" class="ml-auto">
      <v-row v-if="step == 10 || step == 5">
        <b-card
          header-bg-variant="primary"
          header-text-variant="white"
          v-if="reportTypes[selectedReportType].charts"
        >
          <v-row v-if="!loaded"> لطفا چند لحظه صبر کنید... </v-row>
          <v-row v-if="loaded">
            <v-col lg="12">
              <bar-chart
                :chartData="results.ordersPerMonthPrice"
                :options="priceBarChartOptions"
              >
              </bar-chart>
            </v-col>
            <v-col lg="12">
              <hr />
            </v-col>
            <v-col lg="12">
              <bar-chart
                :chartData="results.ordersPerMonthCount"
                :options="countBarChartOptions"
              >
              </bar-chart>
            </v-col>
            <v-col md="6" lg="12">
              <hr class="white" />
            </v-col>
          </v-row>
        </b-card>
        <b-card
          header-bg-variant="primary"
          header-text-variant="white"
          v-if="
            selectedReportType == 'monthItems' &&
            reportTypes[selectedReportType].tables
          "
        >
          <v-btn
            @click="printTable()"
            :disabled="!results.result || !results.result.length"
            style="width: 135px; height: 35px"
            class="white--text darkRed-mainBtn ms-5 float-end"
            depressed
          >
            <v-icon class="me-1"> mdi-printer </v-icon>
            پرینت
          </v-btn>
          <hr />
          <div v-show="false" id="printTable">
            <table>
              <div>
                <tbody>
                  <h3 style="float: right">جدول اقلام</h3>
                  <b-table :items="results.result" :fields="fieldsForPrint">
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(totalPrice)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(stud)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(anchor)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(hex)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(plug)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(Ubolt)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                    <template v-slot:cell(other)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ Number(data.value).toLocaleString() }}
                      </div>
                    </template>
                  </b-table>
                  <hr />
                  <h3 style="float: right">خلاصه اطلاعات</h3>
                  <table
                    class="orderInfoTable"
                    border="1px solid"
                    style="width: 100%"
                  >
                    <tr>
                      <th class="p-1">جمع مبلغ کل اقلام</th>
                      <td class="p-1">
                        {{ results.totalPrice.toLocaleString() }} ریال
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">جمع مبلغ کل استاد بولت‌ها</th>
                      <td class="p-1">
                        {{ results.stud.toLocaleString() }} ریال
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">جمع مبلغ کل انکر بولت‌ها</th>
                      <td class="p-1">
                        {{ results.anchor.toLocaleString() }} ریال
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">جمع مبلغ کل پیچ‌های شش‌گوش</th>
                      <td class="p-1">
                        {{ results.hex.toLocaleString() }} ریال
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">جمع مبلغ کل پلاگ‌ها</th>
                      <td class="p-1">
                        {{ results.plug.toLocaleString() }} ریال
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">جمع مبلغ کل یوبولت‌ها</th>
                      <td class="p-1">
                        {{ results.Ubolt.toLocaleString() }} ریال
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">
                        جمع مبلغ کل مبالغ سایر (مالیات، تخفیف و سایر اقلام
                        سفارش)
                      </th>
                      <td class="p-1">
                        {{ results.other.toLocaleString() }} ریال
                      </td>
                    </tr>
                  </table>
                </tbody>
                <!-- <tfoot>
                  متن تستی 2
                </tfoot> -->
              </div>
            </table>
          </div>
          <h5>جدول اقلام</h5>
          <b-table
            responsive
            bordered
            show-empty
            :items="results.result"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="currentPage"
            :per-page="perPage"
            :busy="!loaded"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + perPage * (currentPage - 1) + 1 }}
              </div>
            </template>
            <template v-slot:cell(code)="data">
              <div style="text-align: center; vertical-align: middle">
                <a
                  :href="'/' + role + '/order/' + data.item.id"
                  target="_blank"
                  >{{ data.item.code }}</a
                >
                <span v-if="data.item.isUrgent" class="text-danger">
                  <i class="mr-1 fa fa-exclamation-triangle"> </i>
                  فوری
                </span>
              </div>
            </template>
            <template v-slot:cell(totalPrice)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <template v-slot:cell(stud)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <template v-slot:cell(anchor)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <template v-slot:cell(hex)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <template v-slot:cell(plug)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <template v-slot:cell(Ubolt)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <template v-slot:cell(other)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="results.result.length"
            align="center"
            size="md"
            class="my-0 mb-3"
          ></b-pagination>
          <hr />
          <h5>خلاصه اطلاعات</h5>
          <table class="orderInfoTable" border="1px solid" style="width: 100%">
            <tr>
              <th class="p-1">جمع مبلغ کل اقلام</th>
              <td class="p-1">
                {{ results.totalPrice.toLocaleString() }} ریال
              </td>
            </tr>
            <tr>
              <th class="p-1">جمع مبلغ کل استاد بولت‌ها</th>
              <td class="p-1">{{ results.stud.toLocaleString() }} ریال</td>
            </tr>
            <tr>
              <th class="p-1">جمع مبلغ کل انکر بولت‌ها</th>
              <td class="p-1">{{ results.anchor.toLocaleString() }} ریال</td>
            </tr>
            <tr>
              <th class="p-1">جمع مبلغ کل پیچ‌های شش‌گوش</th>
              <td class="p-1">{{ results.hex.toLocaleString() }} ریال</td>
            </tr>
            <tr>
              <th class="p-1">جمع مبلغ کل پلاگ‌ها</th>
              <td class="p-1">{{ results.plug.toLocaleString() }} ریال</td>
            </tr>
            <tr>
              <th class="p-1">جمع مبلغ کل یوبولت‌ها</th>
              <td class="p-1">{{ results.Ubolt.toLocaleString() }} ریال</td>
            </tr>
            <tr>
              <th class="p-1">جمع مبلغ کل مبالغ سایر</th>
              <td class="p-1">{{ results.other.toLocaleString() }} ریال</td>
            </tr>
          </table>
        </b-card>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";
import BarChart from "/src/components/charts/BarExample.vue";
import PieChart from "/src/components/charts/PieExample.vue";
import LineChart from "/src/components/charts/LineExample.vue";
import array from "core-js/es7/array";

export default {
  components: {
    BarChart,
    PieChart,
    LineChart,
  },
  data: function () {
    return {
      moment: moment,
      vLoading: false,
      guide: false,
      isBusy: false,
      loaded: false,
      role: "",
      step: 1,
      reportTypes: {
        annualMonthly: {
          name: "فروش ماهیانه یک سال",
          selectType: 2,
          selectYear: 4,
          charts: true,
          tables: false,
        },
        compareMonth: {
          name: "مقایسه فروش یک ماه با سال قبل",
          selectType: 2,
          selectYear: 6,
          charts: true,
          tables: false,
        },
        monthItems: {
          name: "اقلام فروخته شده یک ماه",
          selectType: 2,
          selectYear: 6,
          charts: false,
          tables: true,
        },
        compareMultipleMonth: {
          name: "مقایسه ماه‌ها",
          selectType: 2,
          selectYear: 7,
          charts: true,
          tables: false,
        },
        annualRequestMonthly: {
          name: "پیش‌فاکتورهای ماهیانه یک سال",
          selectType: 2,
          selectYear: 4,
          charts: true,
          tables: false,
        },
      },
      selectedReportType: "",
      selectedYear: 0,
      selectedMonth: 0,
      selectedMonthFrom: 0,
      selectedMonthTo: 0,
      currentYear: 0,
      currentMonth: 0,
      yearMonthList: [],
      results: {},
      fields: [
        { key: "index", label: "#" },
        { key: "code", label: "کد سفارش" },
        { key: "factoryCode", label: "شماره پیگیری کارخانه" },
        { key: "date", label: "تاریخ ابلاغ", sortable: true },
        { key: "customer", label: "نام مشتری" },
        { key: "totalPrice", label: "مبلغ کل (ریال)" },
        { key: "stud", label: "استاد بولت (ریال)", sortable: true },
        { key: "anchor", label: "انکربولت (ریال)", sortable: true },
        { key: "hex", label: "پیچ شش گوش (ریال)", sortable: true },
        { key: "plug", label: "پلاگ (ریال)", sortable: true },
        { key: "Ubolt", label: "یوبولت (ریال)", sortable: true },
        {
          key: "other",
          label: "سایر اقلام و اختلاف قیمت (مالیات، تخفیف و غیره)",
          sortable: true,
        },
      ],
      fieldsForPrint: [
        { key: "index", label: "#" },
        { key: "code", label: "کد سفارش" },
        { key: "factoryCode", label: "شماره پیگیری کارخانه" },
        { key: "date", label: "تاریخ ابلاغ" },
        { key: "customer", label: "نام مشتری" },
        { key: "totalPrice", label: "مبلغ کل" },
        { key: "stud", label: "استاد بولت" },
        { key: "anchor", label: "انکربولت" },
        { key: "hex", label: "پیچ شش گوش" },
        { key: "plug", label: "پلاگ" },
        { key: "Ubolt", label: "یوبولت" },
        {
          key: "other",
          label: "سایر اقلام",
        },
      ],
      currentPage: 1,
      perPage: 10,
      countBarChartOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "تعداد در هر ماه",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: this.fetchMonthData,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "تعداد در هر ماه",
                fontFamily: "iransans",
              },
              ticks: {
                min: 0,
                fontFamily: "iransans",
                stepSize: 50,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
        },
      },
      priceBarChartOptions: {
        title: {
          display: true,
          fontSize: 14,
          position: "top",
          fontFamily: "iransans",
          text: "مبلغ در هر ماه",
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "مبلغ در هر ماه (میلیون تومان)",
                fontFamily: "iransans",
              },
              ticks: {
                min: 0,
                fontFamily: "iransans",
                callback: function (value, index, values) {
                  return value.toLocaleString();
                },
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans",
              },
              ticks: {
                fontFamily: "iransans",
              },
            },
          ],
        },
        legend: {
          display: true,
          position: "bottom",
          labels: {
            usePointStyle: true,
            fontFamily: "iransans",
          },
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans",
          callbacks: {
            title: function (tooltipItem, data) {
              return data["labels"][tooltipItem[0]["index"]];
            },
            label: function (tooltipItem, data) {
              var myLabel =
                data["datasets"][tooltipItem.datasetIndex]["label"] +
                ": " +
                (
                  Math.round(
                    data["datasets"][tooltipItem.datasetIndex]["data"][
                      tooltipItem["index"]
                    ] / 100
                  ) / 10
                ).toLocaleString() +
                " میلیارد تومان";
              return myLabel;
            },
          },
        },
      },
    };
  },
  methods: {
    selectReportType(step) {
      this.selectedReportType = step;
      this.step = this.reportTypes[this.selectedReportType].selectType;
    },
    selectReportYear(year) {
      this.selectedYear = year;
      this.step = this.reportTypes[this.selectedReportType].selectYear;
    },
    selectReportMonth(month) {
      this.selectedMonth = month;
      this.step = 9;
    },
    selectReportMonthFrom(month) {
      this.selectedMonthFrom = month;
      this.step = 8;
    },
    selectReportMonthTo(month) {
      this.selectedMonthTo = month;
      this.step = 9;
    },
    produceReport() {
      this.loaded = false;
      Axios.post(
        this.baseUrl + "/ppkpms/office/reports/sales",
        {
          type: this.selectedReportType,
          year: this.selectedYear,
          monthFrom: this.selectedMonthFrom ? this.selectedMonthFrom : null,
          monthTo: this.selectedMonthTo ? this.selectedMonthTo : null,
          month: this.selectedMonth ? this.selectedMonth : null,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.results = res.data;
            
            setTimeout(() => {
              this.loaded = true;
              this.vLoading = false;
            }, 500);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
      if (this.step == 4) {
        this.step = 5;
      } else this.step = 10;
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    printTable() {
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    returnReport() {
      this.step = 1;
      this.selectedMonth = null;
      this.selectedMonthFrom = null;
      this.selectedMonthTo = null;
    },
  },

  mounted() {
    this.role = window.localStorage.getItem("role");
    var currentDate = new Date();
    this.currentYear = Number(moment(currentDate).format("jYYYY"));
    this.currentMonth = Number(moment(currentDate).format("jMM"));
    for (let year = 1399; year <= this.currentYear; year++) {
      var monthList = [];
      if (year == this.currentYear) {
        monthList = Array.from({ length: this.currentMonth }, (_, i) => i + 1);
      } else {
        monthList = Array.from({ length: 12 }, (_, i) => i + 1);
      }
      this.yearMonthList.push({ year: year, month: monthList });
    }

    // Generate Print Fields based on Table Fields
    // this.fieldsForPrint = this.fields.map((x) => {
    //   return {
    //     key: x.key,
    //     label: x.label,
    //   };
    // });
  },
};
</script>

<style>
* {
  font-family: iransans;
}

@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

@media print {
  @page {
    margin: 0;
    size: a4 landscape;
    font-size: 30%;
    text-color: black;
  }
}
</style>
